import { PayoutSettings } from "@wingspanhq/wingspan-api-sdk";
import { selectorPayoutSettingsInstantFee } from "@selectors/selectorPayoutSettingsInstantFee";

class InstantPayoutService {
  calculateInvoiceInstantPayoutFee(
    amount: number,
    payoutSettings?: PayoutSettings
  ) {
    const instantPayoutDefaultFee =
      selectorPayoutSettingsInstantFee(payoutSettings);
    const instantPayoutDefaultFeeMultiplier = instantPayoutDefaultFee / 100;

    const instantPayoutFee = amount * instantPayoutDefaultFeeMultiplier;

    // Prevent setting 0.5 if the fee amount is 0
    if (instantPayoutFee === 0) {
      return 0;
    }

    if (instantPayoutFee < 0.5) {
      return 0.5;
    }

    return instantPayoutFee;
  }
}

export const instantPayoutService = new InstantPayoutService();
